import React, {  useState } from 'react';
import { Drawer, IconButton } from '@mui/material';
import { CiHeart } from "react-icons/ci";
import { IoMdClose } from "react-icons/io";
import { openWhislist } from '../../../Redux/Action/action';
import { useDispatch, useSelector } from 'react-redux';
import './style/wishlist.css';
import productdata from '../../../json/product.json';
import { IKImage } from 'imagekitio-react';
import { RiDeleteBin6Fill } from "react-icons/ri";
import { GiCycle, GiNecklaceDisplay, GiPearlEarring, GiGemChain } from "react-icons/gi";
import { useNavigate } from 'react-router-dom';
import { whislistDataAction } from '../../../Redux/Action/whislistDataAction';


const Whislist = () => {

    const id = JSON.parse(localStorage.getItem('productids'));
    const data = productdata?.newPrd?.filter((x) => id?.includes(x?.id));
    const [state, setState] = useState({ right: false, sidebarHeight: "100vh" });

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isopen = useSelector(state => state.wishlist.Whislist);

    const handleDelete = (id) => {
        const storedIds = JSON.parse(localStorage.getItem('productids'));
        if (storedIds && Array.isArray(storedIds)) {
            const indexToRemove = storedIds.indexOf(id);
            if (indexToRemove !== -1) {
                storedIds.splice(indexToRemove, 1);
                localStorage.setItem('productids', JSON.stringify(storedIds));
                dispatch(openWhislist(false));
                dispatch(whislistDataAction(storedIds))
            }
        }
    };
    const handleCancel = () => {
        localStorage.removeItem('productids');
    };
   

    const handleNavigate = () => {
        dispatch(openWhislist(false))
        navigate("/category")
    }
    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
        if (!open) {
            dispatch(openWhislist(false));
        }
    };
    return (
        <div>
            {/* <div onClick={handleIconButtonClick} style={{ color: scrollIconColor, paddingLeft: '10px', cursor: 'pointer' }} className="text-2xl text-white">
                <CiHeart />
            </div> */}
            <Drawer
                anchor='right'
                open={isopen}
                onClose={toggleDrawer('right', false)}
                className='whislist-drawer'

            >
                <div className='flex justify-between p-3'>
                    <span className="text-xl bg-transparent text-black" onClick={() => dispatch(openWhislist(false))}>
                        <IoMdClose className="cursor-pointer" />
                    </span>
                    <span className="text-xl bg-transparent text-black" onClick={handleCancel}>
                        <GiCycle className="cursor-pointer" />
                    </span>
                </div>
                <div className='border p-2 my-5 text-black bg-gray-200 tracking-wider text-sm'>
                    These products are limited, checkout fast....
                </div>
                <div className='flex justify-evenly'>
                    <p className='text-black text-6xl border rounded-full p-2 cursor-pointer' onClick={handleNavigate}><GiNecklaceDisplay /></p>
                    <p className='text-black text-6xl border rounded-full p-2 cursor-pointer' onClick={handleNavigate}><GiPearlEarring /></p>
                    <p className='text-black text-6xl border rounded-full p-2 cursor-pointer' onClick={handleNavigate}><GiGemChain /></p>
                </div>
                <h2 className='text-lg p-3 text-black my-5'>Your Wishlist</h2>
                <hr />
                {data && data.length > 0 ? (
                    <div>
                        {data.map((x) => {
                            const productdata = x;
                            if (!productdata) {
                                return null;
                            }
                            return (
                                <div key={productdata.id} className="text-sm flex justify-between p-5">
                                    <div className="me-3">
                                        <IKImage
                                            src={JSON.parse(productdata.prdimg)?.[0]?.url}
                                            style={{ width: "80px", height: '80px' }}
                                        />
                                    </div>
                                    <div className='text-gray-600'>
                                        <div>{productdata.prdname}</div>
                                        <div className='flex capitalize'>
                                            price on request
                                        </div>
                                    </div>
                                    <IconButton aria-label="delete" className="hover:text-black flex justify-end " onClick={() => handleDelete(x.id)}>
                                        <RiDeleteBin6Fill className='text-lg -mt-12' />
                                    </IconButton>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className="text-center text-lg mt-5 flex justify-start">
                        <span> <CiHeart className='text-7xl text-gray-600 -mt-3' /></span>
                        <div>
                            <p className='text-sm'>There are no products on the wishlist!</p>
                            <p className='text-base text-black underline text-start cursor-pointer ' onClick={handleNavigate}>Start Shopping</p>
                        </div>
                        {/* <img src={whislistIcons} alt="whislisticons" className='h-2/3 w-2/3 '/>
                        <p></p> */}
                    </div>
                )}
            </Drawer>
        </div>
    );
};

export default Whislist;